import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {generateToggleButton} from '#core/application/modules/tiles/button/index.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';

export function competitionsKnockoutGridFactory(PALETTE) {
    return {
        EventBracket: {
            emptyContainer: {
                style: {
                    ...PALETTE.KNOCKOUT_GRID_NOT_AVAILABLE_TEXT,
                },
            },
            container: {
                style: {
                    padding: '16px 0 0',
                },
            },
            bracketGrid: {
                style: {
                    padding: '0 0 8px',
                },
            },
            navigation: {
                tabs: {
                    item: generateToggleButton(PALETTE.KNOCKOUT_GRID_PHASE_SWITCHER, true),
                },
            },
            connectors: {
                strokeColor: PALETTE.KNOCKOUT_GRID_PAIR_NODE_CONNECTOR_COLOR,
            },
            node: {
                bracketNodeContainer: {
                    itemSpacing: 8,
                    style: {
                        padding: 8,
                        ...resolveBackground(PALETTE.KNOCKOUT_GRID_PAIR_NODE_CONTAINER_BG),
                        ...generateBorder(PALETTE.KNOCKOUT_GRID_PAIR_NODE_CONTAINER_BORDER),
                    },
                },
                bracketNodeStatus: {
                    container: {
                        ...resolveBackground(PALETTE.KNOCKOUT_GRID_PAIR_NODE_STATUS_CONTAINER_BG),
                        ...generateBorder(PALETTE.KNOCKOUT_GRID_PAIR_NODE_STATUS_CONTAINER_BORDER),
                    },
                    style: {
                        ...PALETTE.KNOCKOUT_GRID_PAIR_NODE_STATUS_TEXT,
                    },
                },
                liveEventTimingStatus: {
                    container: {
                        style: {
                            base: {
                                ...resolveBackground(PALETTE.KNOCKOUT_GRID_PAIR_NODE_STATUS_CONTAINER_BG),
                                ...generateBorder(PALETTE.KNOCKOUT_GRID_PAIR_NODE_STATUS_CONTAINER_BORDER),
                            },
                        },
                    },
                    dateTimeContainer: {
                        style: {
                            justifyContent: 'center',
                        },
                    },
                    liveText: {
                        style: {
                            ...PALETTE.KNOCKOUT_GRID_PAIR_NODE_STATUS_TEXT,
                        },
                    },
                },
                bracketNodeMarkets: {
                    style: {
                        padding: '0 0 8px',
                    },
                },
                bracketSlot: {
                    bracketSlotButton: {
                        style: {
                            base: {
                                padding: 0,
                                ...resolveBackground(PALETTE.KNOCKOUT_GRID_PAIR_NODE_TEAM_CONTAINER_BG),
                                ...generateBorder(PALETTE.KNOCKOUT_GRID_PAIR_NODE_TEAM_CONTAINER_BORDER),
                            },
                        },
                    },
                    countryOrSportIcon: {
                        sportIcon: {
                            icon: icon(PALETTE.KNOCKOUT_GRID_PAIR_NODE_TEAM_SPORT_ICON_COLOR),
                        },
                    },
                    teamName: {
                        style: {
                            ...PALETTE.KNOCKOUT_GRID_PAIR_NODE_TEAM_NAME_TEXT,
                        },
                    },
                    score: {
                        container: {
                            borderRadius: 4,
                            margin: '0 8px 0 0',
                            ...resolveBackground(PALETTE.KNOCKOUT_GRID_PAIR_NODE_SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_BG),
                        },
                        style: {
                            textAlign: 'center',
                            ...PALETTE.KNOCKOUT_GRID_PAIR_NODE_SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_TEXT,
                        },
                    },
                },
                selectionButton: generateOddsButton(PALETTE.KNOCKOUT_GRID_PAIR_NODE_ODDS_BUTTON),
                market: {
                    selectionButton: generateOddsButton(PALETTE.KNOCKOUT_GRID_PAIR_NODE_ODDS_BUTTON),
                },
                winnerText: {
                    container: {
                        ...resolveBackground(PALETTE.KNOCKOUT_GRID_PAIR_NODE_WINNER_CONTAINER_BG),
                    },
                    style: {
                        ...PALETTE.KNOCKOUT_GRID_PAIR_NODE_WINNER_TEXT,
                    },
                },
            },
        },
        EventBracketSkeleton: {
            navigationItem: generateSkeletonPart(PALETTE.KNOCKOUT_GRID_SKELETON_PART),
            nodeCard: generateSkeletonPart(PALETTE.KNOCKOUT_GRID_SKELETON_PART),
            connectorSegment: generateSkeletonPart(PALETTE.KNOCKOUT_GRID_SKELETON_PART),
        },
    };
}
